import ExportRequestsPage from '@/features/agent/export_requests/pages/ExportRequestsPage';

export default function ExportRequestsTemplate() {
  return <ExportRequestsPage />;
}
